import React from 'react';
import PropTypes from 'prop-types';
import Editor from 'react-simple-wysiwyg';

const ConsultationEditor = ({
  notes, setNotes, onSubmit, submitting, onCancel, isEditing,
}) => {
  let buttonText = 'Save Consultation';
  if (submitting) {
    buttonText = 'Saving...';
  } else if (isEditing) {
    buttonText = 'Update Note';
  }

  return (
    <div>
      <h3 className="text-lg font-semibold">
        {isEditing ? 'Edit Consultation Note' : 'Add New Consultation Note'}
      </h3>
      <Editor
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />
      <div className="flex gap-[10px] mt-2">
        <button
          type="button"
          onClick={onSubmit}
          disabled={submitting}
          className="primary wide"
        >
          {buttonText}
        </button>
        {isEditing && (
          <button
            onClick={onCancel}
            type="button"
            className="bg-gray-400 text-white px-4 py-2 rounded"
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

ConsultationEditor.propTypes = {
  notes: PropTypes.string.isRequired,
  setNotes: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export default ConsultationEditor;
